// Copyright (c) Docugami, Inc. All rights reserved.

import { IDocumentCommand } from "components/file_management/DocumentCommand";
import { downloadFileFromUrl } from 'components/file_management/file_helpers';
import { Config } from 'config';
import { createSelectFolderIdsWithCpmlFromFilePaths } from 'filemanager/selectors';
import { DownloadFilesDgmlRequest } from 'networking/api';
import { useCallback } from 'react';
import { RequestState, useAsyncHelper } from './AsyncHelper';
import { useAppSelector } from './redux';

const selectFolderIdsWithCpmlFromFilePaths = createSelectFolderIdsWithCpmlFromFilePaths();
export const useDownloadDgmlCommand = (items: string[], zipName?: string): IDocumentCommand => {
    const namedFolderIds = useAppSelector(state => selectFolderIdsWithCpmlFromFilePaths(state, items));
    const { execute: executeDownload, state: downloadStatus } = useAsyncHelper("Download dgml files");

    const download = useCallback(() => {
            const filename = namedFolderIds.length === 1 ? `${namedFolderIds[0].fileName}.xml` : `${zipName ?? 'dgml'}.zip`;
            executeDownload(downloadFileFromUrl(
                `${Config.fileManagerApiUrl}/files/semanticdgml`,
                filename,
                'POST', {
                    files: namedFolderIds
                } as DownloadFilesDgmlRequest
            ))
    }, [executeDownload, namedFolderIds, zipName]);

    const isActive = downloadStatus === RequestState.InProgress;
    return {
        id: "downloadDgmlCommand",
        isActive: isActive,
        label: !isActive ? "Download DGML" : "Downloading...",
        isEnabled: !!namedFolderIds.length,
        visual: null,
        execute: download
    }
}